var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThrowIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 69,
    viewBox: "0 0 30 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "goalkeeper (2) 1",
    clipPath: "url(#clip0_68_120298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.038 66.1904L26.5326 52.6328C26.5564 52.4129 26.5537 52.1909 26.5235 51.9719L25.4472 44.2048L24.3203 27.9028C24.3203 27.9028 24.3841 27.7883 25.719 15.8808C25.7795 15.3293 25.6219 14.7752 25.2801 14.3382L18.9701 6.2599C18.6773 5.88455 18.283 5.63687 17.8569 5.5199C17.8939 5.71872 17.922 5.92029 17.9394 6.12338C18.0671 7.63881 17.6422 9.11545 16.741 10.3239L18.1608 12.1414C21.5966 11.9741 24.5417 14.5819 24.7774 18.0239C24.8929 19.7091 24.3447 21.3384 23.2345 22.6117C22.4875 23.4686 21.5453 24.0944 20.4953 24.4475L15.6507 25.0604L10.577 17.2533L10.2731 12.6249C9.20751 12.3552 8.22136 11.8021 7.42364 11.0044C6.51352 10.0943 5.9134 8.91999 5.70236 7.65652C5.67976 7.97292 5.66999 7.35967 6.36326 18.0868C6.38739 18.4505 6.50405 18.8023 6.70287 19.108L12.3468 27.792C12.3468 27.792 12.301 27.828 13.3803 43.8167C13.3562 43.9202 12.1199 49.919 11.5036 52.9046L3.94964 62.8273C3.05479 64.0025 3.27927 65.6832 4.45814 66.5811C5.63548 67.4774 7.31583 67.2496 8.21189 66.0726L16.1347 55.6649C16.3779 55.3461 16.5458 54.9765 16.6271 54.5838L18.5548 45.2396L20.167 45.1293L21.1709 52.3769L19.7126 65.6031C19.5507 67.074 20.6114 68.3973 22.0816 68.5592C23.5522 68.7213 24.8755 67.6607 25.038 66.1904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.1569 18.137C22.9795 15.5475 20.7366 13.5916 18.1473 13.7688C15.5575 13.9459 13.6017 16.1888 13.7788 18.7787C13.9559 21.3679 16.1988 23.3237 18.7884 23.1469C21.3782 22.9698 23.3337 20.7265 23.1569 18.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.25844 7.0236C7.47039 9.53588 9.67879 11.3833 12.1721 11.1732C14.6749 10.9621 16.5327 8.76228 16.3217 6.25947C16.1097 3.74659 13.9001 1.8998 11.408 2.10991C8.90519 2.32095 7.04741 4.52079 7.25844 7.0236Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_120298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrowIn);
export default __webpack_public_path__ + "static/media/throw-in.c13ba4f753f03447dc4dda4b3d3af9ac.svg";
export { ForwardRef as ReactComponent };